import { apiClient } from './client';

/**
 * CRM activities/tasks — calls, meetings, emails, notes, and follow-up
 * tasks logged against a client organization, a lead, or an org member.
 * See B2B phase-2 contract (Agent 3 backend / Agent 5 frontend).
 */

/**
 * List activities, optionally filtered.
 * @param {{ orgId?: string, leadId?: string, ownerId?: string, type?: string, completed?: boolean|string }} params
 */
export async function getActivities(params = {}) {
  const { data } = await apiClient.get('/activities', { params });
  return data;
}

export async function createActivity(body) {
  const { data } = await apiClient.post('/activities', body);
  return data;
}

export async function updateActivity(id, body) {
  const { data } = await apiClient.patch(`/activities/${id}`, body);
  return data;
}

/** Marks an activity/task as complete (sets completedAt server-side). */
export async function completeActivity(id) {
  const { data } = await apiClient.patch(`/activities/${id}`, { complete: true });
  return data;
}

export async function deleteActivity(id) {
  const { data } = await apiClient.delete(`/activities/${id}`);
  return data;
}

/**
 * Current user's open tasks split into overdue / today / upcoming buckets.
 * @returns {Promise<{ overdue: object[], today: object[], upcoming: object[] }>}
 */
export async function getMyTasks() {
  const { data } = await apiClient.get('/activities/my-tasks');
  return data;
}
